module.exports = __webpack_public_path__ + "static/media/x-circle-fill.6760b715.svg";